import { Action } from '@ngrx/store';

/**
 * SearchActionTypes
 */
export const enum SearchActionTypes {
  LOAD_SEARCH_TERM = '[Search] Load Search Term',
  CLEAR_SEARCH_TERM = '[Search] Clear Search Term',
}

/**
 * LoadSearchTerm
 */
interface LoadSearchTerm extends Action {
  type: SearchActionTypes.LOAD_SEARCH_TERM;
  payload: any;
}

/**
 * ClearSearchTerm
 */
interface ClearSearchTerm extends Action {
  type: SearchActionTypes.CLEAR_SEARCH_TERM;
}

/**
 * SearchActions
 */
export type SearchActions = LoadSearchTerm | ClearSearchTerm;
